import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

const InventoryBadge = ({ count, inventory, soldOut = false, className = '' }) => {
  const stock = count ?? inventory ?? 0
  const isSoldOut = soldOut || stock <= 0
  const isLowStock = !isSoldOut && stock <= 50

  const getBadgeClass = () => {
    if (isSoldOut) return 'inventory-badge--sold-out'
    if (isLowStock) return 'inventory-badge--low'
    return 'inventory-badge--normal'
  }

  const renderText = () => {
    if (isSoldOut) return 'Sold out'
    if (isLowStock) return `Only ${stock} left`
    return `${stock} in stock`
  }

  return (
    <div className={`inventory-badge ${getBadgeClass()} ${className}`.trim()}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      </svg>
      <span>{renderText()}</span>
    </div>
  )
}

InventoryBadge.propTypes = {
  count: PropTypes.number,
  inventory: PropTypes.number,
  soldOut: PropTypes.bool,
  className: PropTypes.string,
}

export default InventoryBadge
